export const ImageFilesAllowed = ['tiff', 'jfif', 'bmp', 'jpg', 'jpeg', 'png', 'gif', 'svg', 'webp', 'ico', 'svgz', 'xbm', 'dib', 'pjp', 'apng', 'tif', 'pjpeg', 'avif'];
